import classes from "./PageContainerComponent.module.css";

interface Props {
  children: any;
}

export default function PageContainerComponent(props: Props) {
  return <main className={classes.pageContainer}>{props.children}</main>;
}
